import React from "react";
import { TitleSection } from "../title-section";
import PieChart from "./pie-chart";
import BarChart from "./bar-chart";
import LineChart from "./line-chart";
import RadarChart from "./radar-chart";

export const StatisticsDashboard = () => {
  return (
    <section
      id="estatisticas"
      className="w-full py-10 px-4 lg:mx-0 flex justify-center"
    >
      <div className="w-full lg:max-w-screen-md xl:max-w-screen-xl 2xl:max-w-screen-2xl">
        <div className="">
          <TitleSection blueToRed first_title="Estatísticas" />
          <div className="space-y-10">
            <div className="flex flex-col md:flex-row items-center justify-between w-full space-y-6 md:space-y-0 md:space-x-10">
              <div className="w-full md:w-1/2">
                <BarChart
                  indexAxis="y"
                  title="Autores mais citados no ENEM"
                  labels={[
                    "Aristóteles",
                    "Mill",
                    "Descartes",
                    "Platão",
                    "Foucault",
                    "Nietzsche",
                    "Weber",
                    "Sartre",
                  ]}
                  values={[13, 8, 8, 7, 7, 6, 4, 4, 3]}
                />
              </div>
              <div className="md:w-1/2">
                <div className="text-left">
                  <h2 className="text-xl md:text-2xl text-blue-500 font-semibold leading-tight">
                    Autores mais citados no ENEM
                  </h2>
                  <p className="text-gray-600 text-sm md:text-base mt-4">
                    No Enem, alguns filósofos são frequentemente citados por
                    suas contribuições ao pensamento ocidental. Aristóteles
                    lidera com 13 menções, destacando-se por sua ética e
                    política. John Stuart Mill e René Descartes aparecem com 8
                    citações cada; Mill é lembrado pelo utilitarismo e defesa da
                    liberdade, enquanto Descartes é essencial para a filosofia
                    moderna com seu "Penso, logo existo". Platão e Foucault,
                    ambos com 7 menções, são fundamentais para compreender
                    teoria do conhecimento e relações de poder. Nietzsche (6)
                    critica a moral tradicional, enquanto Weber (4) analisa
                    sociedade e burocracia. Sartre, com 3 citações, traz o
                    existencialismo e a liberdade individual.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col md:flex-row items-center justify-between w-full space-y-6 md:space-y-0 md:space-x-10">
              <div className="md:w-1/2 text-left">
                <h2 className="text-xl md:text-2xl text-blue-500 font-semibold leading-tight">
                  Relações com Conceitos Historiográficos
                </h2>
                <p className="text-gray-600 text-sm md:text-base mt-4">
                  As provas do Enem frequentemente abordam Conceitos
                  Historiográficos essenciais para a compreensão da sociedade.
                  "Tempo" e "Cultura" aparecem com 37 menções cada, destacando a
                  relação entre mudanças históricas e manifestações culturais.
                  "Espaço" (35) é central para entender a organização
                  territorial e geopolítica. "Política" (34) reflete a
                  importância dos sistemas de governo e participação social. O
                  "Passado" (31) reforça a ideia de aprendizado com a história.
                  "Revolução" (28) remete a transformações marcantes, enquanto
                  "Ditadura" (16) e "Totalitarismo" (4) evidenciam debates sobre
                  regimes autoritários e suas consequências.
                </p>
              </div>

              <div className="w-full md:w-1/2 order-first md:order-last">
                <PieChart
                  title="Relações com Conceitos Historiográficos"
                  labels={[
                    "Tempo",
                    "Cultura",
                    "Espaço",
                    "Política",
                    "Passado",
                    "Revolução",
                    "Ditadura",
                    "Totalitarismo",
                  ]}
                  values={[37, 37, 35, 34, 31, 28, 16, 4]}
                />
              </div>
            </div>

            {/* Gráfico na parte superior direita ocupando 2 colunas */}
            <div className="flex flex-col md:flex-row items-center justify-between w-full space-y-6 md:space-y-0 md:space-x-10">
              <div className="w-full md:w-1/2">
                <BarChart
                  indexAxis="x"
                  title="Conceitos mais recorrentes na prova de humanas"
                  labels={[
                    "Cultura",
                    "Poder",
                    "Movimento",
                    "Ética",
                    "Revolução",
                    "Território",
                    "Justiça",
                    "Realidade",
                    "Liberade",
                    "Existência",
                  ]}
                  values={[37, 37, 35, 35, 28, 29, 29, 29, 30, 30]}
                />
              </div>

              <div className="md:w-1/2 text-left">
                <h2 className="text-xl md:text-2xl text-blue-500 font-semibold leading-tight">
                  Conceitos mais recorrentes na prova de humanas
                </h2>
                <p className="text-gray-600 text-sm md:text-base mt-4">
                  Na prova de Humanas do Enem, alguns conceitos são recorrentes
                  por sua relevância na compreensão da sociedade. "Cultura" e
                  "Poder" lideram com 37 menções, destacando a influência das
                  práticas sociais e das relações de dominação. "Movimento" e
                  "Ética" (35) abordam dinâmicas sociais e princípios morais.
                  "Revolução" (28) remete a mudanças históricas, enquanto
                  "Território" (29) é essencial na geopolítica. "Justiça",
                  "Realidade" e "Liberdade" (29-30) refletem debates sobre
                  direitos, percepções e autonomia. "Existência" (30) traz
                  discussões filosóficas sobre o ser e sua relação com o mundo.
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row items-center justify-between w-full space-y-6 md:space-y-0 md:space-x-10">
              <div className="md:w-1/2 text-left">
                <h2 className="text-xl md:text-2xl text-blue-500 font-semibold leading-tight">
                  Relações com termos socioculturais
                </h2>
                <p className="text-gray-600 text-sm md:text-base mt-4">
                  Os termos socioculturais mais recorrentes no Enem refletem
                  debates sobre diversidade e inclusão. "Mulher" e "Raça"
                  aparecem com 37 menções, abordando desigualdades e lutas por
                  direitos. "Indígenas" e "Gênero" (35) ressaltam questões
                  identitárias e de representação. "Religião" (28) discute sua
                  influência na sociedade e na formação cultural.
                  "Afro-brasileiro" (29) evidencia a valorização da cultura e da
                  história negra no Brasil. "LGBT" (29) reflete a luta por
                  direitos e reconhecimento da diversidade de gênero e
                  sexualidade. Esses temas são centrais para a construção de uma
                  sociedade mais inclusiva e consciente das diferenças.
                </p>
              </div>
              <div className="w-full md:w-1/2 order-first md:order-last">
                <LineChart
                  title="Relações com termos socioculturais"
                  labels={[
                    "Mulher",
                    "Raça",
                    "Indígenas",
                    "Gênero",
                    "Religião",
                    "Afro-brasileiro",
                    "LGBT",
                  ]}
                  values={[37, 37, 35, 35, 28, 29, 29, 29, 30, 30]}
                />
              </div>
            </div>
            {/* Gráficos menores na parte inferior direita */}

            <div className="flex flex-col md:flex-row items-center justify-between w-full space-y-6 md:space-y-0 md:space-x-10">
              <div className="w-full md:w-1/2">
                <RadarChart />
              </div>
              <div className="md:w-1/2 text-left">
                <h2 className="text-xl md:text-2xl text-blue-500 font-semibold leading-tight">
                  Assuntos de História mais utilizados na prova do ENEM
                </h2>
                <p className="text-gray-600 text-sm md:text-base mt-4">
                  Confira os temas mais cobrados nas provas de Humanas,
                  organizados por matéria. Na Geografia, Urbanização e
                  Agropecuária lideram os conteúdos. Filosofia enfatiza temas
                  como Filosofia Política e Moral e Ética, enquanto Sociologia
                  traz destaque para Direito, Cidadania e Movimentos Sociais,
                  além de Cultura e Sociedade.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
